import styled from 'styled-components';

export const StyledTermModalBody = styled.div``;
